import {
  ProfileModalContainer,
  ProfileModalWrapper,
  ProfileNav,
  ProfileDetails,
  ProfileButton,
  ProfileImageDetails,
  ProfileBio,
} from "./style";
import { FiX, FiVideo, FiPhone } from "react-icons/fi";
import { BiShare, BiTrash, BiFlag, BiBlock } from "react-icons/bi";
import axios from "axios";

interface ProfileModalProps {
  handleProfileModal: () => void;
  closeFunc: () => void;
  userName: string;
  userId: string;
  conversationId: string;
  avatar: string;
 
}

const ProfileModal = ({
  handleProfileModal,
  closeFunc,
  userName,
  conversationId,
  userId,
  avatar,
}: ProfileModalProps) => {
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;

  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const deleteConversation = () => {
    axios
      .delete(
        `${process.env.REACT_APP_API_BASE_ENDPOINT}/remove-conversation/${conversationId}`,
        {
          headers: Authorization,
        }
      )
      .then((res: any) => {
        closeFunc();
        console.log(res.data);
      })
      .catch((err: any) => {
        console.log(err.res);
      });
  };

const handleImageView = () => {

}
  return (
    <>
      <ProfileModalContainer>
        <ProfileModalWrapper>
          <ProfileNav>
            <div>
              <FiX onClick={handleProfileModal} />
            </div>
            <div>
              <span>
                <FiVideo />
              </span>
              <span>|</span>
              <span>
                <FiPhone />
              </span>
            </div>
          </ProfileNav>
          <ProfileDetails>
            <ProfileImageDetails>
              <img onClick={handleImageView} src={avatar || "/image/user101.png"} alt="profile-pic" />
              <div>
                <span>{userName}</span>
                <span>samuelmeshach454@yahoo.com</span>
              </div>
            </ProfileImageDetails>
            <ProfileBio>
              <span>bio</span>
              <span>pleasure to be here with all of you.</span>
            </ProfileBio>
          </ProfileDetails>

          <ProfileButton>
            <div>
              <BiShare size={18} />
              <span> share contact</span>
            </div>
            <div onClick={deleteConversation}>
              <BiTrash size={18} />
              <span>delete chat</span>
            </div>
            <div>
              <BiFlag size={18} />
              <span>report user</span>
            </div>
            <div>
              <BiBlock size={18} color="red" />
              <span>block user</span>
            </div>
          </ProfileButton>
        </ProfileModalWrapper>
      </ProfileModalContainer>
    </>
  );
};
export default ProfileModal;
